import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  OpsBreachingResponse,
  OpsPickUpResponse,
  OpsQueueSummary,
} from './ops-summary.types';

@Injectable({ providedIn: 'root' })
export class OpsSummaryService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/ops`;

  /** Work-queue summary for the Ops dashboard (intake over last `days` days). */
  get(days = 14): Observable<OpsQueueSummary> {
    return this.http.get<OpsQueueSummary>(`${this.base}/queue-summary/`, {
      params: { days },
    });
  }

  /** Every still-open item past its SLA deadline, most overdue first. */
  breaching(): Observable<OpsBreachingResponse> {
    return this.http.get<OpsBreachingResponse>(`${this.base}/breaching/`);
  }

  /**
   * Assign the requesting user to an application they are permitted to pick up.
   * Returns 409 if already assigned to someone else, 404 if not found.
   */
  pickUp(product: 'KS' | 'DF', shortId: string): Observable<OpsPickUpResponse> {
    return this.http.post<OpsPickUpResponse>(`${this.base}/pick-up/`, {
      product,
      short_id: shortId,
    });
  }
}
